import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

function MinusSign({ size, color, ...rest }: IIconType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...rest}
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M21 14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z"
        fill={color}
        data-name="Filled Icons"
      />
    </svg>
  );
}

export default MinusSign;
